import React from "react"
import { graphql, StaticQuery } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"

import "../utils/normalize.css"
import "../utils/css/screen.css"

const AboutPage = ({ data }, location) => {
  const siteTitle = data.site.siteMetadata.title

  return (
    <Layout title={siteTitle}>
      <SEO title="Contact BHS Coach Devizes, Wiltshire" />

      <article className="post-content page-template no-image">
        <div className="post-content-body">
          <h2>
            Contact Louise
          </h2>
          <figure className="kg-card kg-image-card kg-width-full">
            <Img
              fluid={data.contactImg.childImageSharp.fluid}
              className="kg-image"
            />
          </figure>
          
          <p align="center" className="lead">For all enquiries please call or text</p>

          <p align="center" className="lead"><a href="tel:07917341804">07917 341804</a></p>
          
        </div>
      </article>
    </Layout>
  )
}

const indexQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    contactImg: file(
      relativePath: { eq: "contact.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 1360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default props => (
  <StaticQuery
    query={indexQuery}
    render={data => (
      <AboutPage location={props.location} data={data} {...props} />
    )}
  />
)
